import axios from 'axios';
import { API_V1_PREFIX } from '../utils/constants';

export interface ParsedBiomarker {
  biomarker_id?: number;
  biomarker_name: string;
  value: string;
  unit?: string;
  summary?: string;
}

export interface ParseBloodReportResponse {
  success: boolean;
  data: {
    biomarkers?: ParsedBiomarker[];
    matched_biomarkers?: any[];
    missing_list?: Array<{ biomarker_name: string; standard_unit: string }>;
    summary?: Record<string, any>;
    [key: string]: any;
  };
  error?: string;
}

export const parseBloodReportByFilename = async (
  filename: string,
  filePath?: string
): Promise<ParseBloodReportResponse> => {
  try {
    // Hardcoded host - always use ukstaging.getscanned.me regardless of staging or production
    const baseURL = 'https://ukstaging.getscanned.me';
    const cleanBaseURL = baseURL.endsWith('/') ? baseURL.slice(0, -1) : baseURL;

    // Create a new axios instance for GS_URL (no auth token required)
    const client = axios.create({
      baseURL: cleanBaseURL,
      headers: {
        'Content-Type': 'application/json'
      }
    });
    const url = `${API_V1_PREFIX}parse_blood_report_by_filename`;

    console.log('Using hardcoded GS_URL:', cleanBaseURL);
    console.log('Full URL will be:', `${cleanBaseURL}/${url}`);

    console.log('Making request to:', url);
    console.log('Request payload:', { filename, file_path: filePath });

    const { data } = await client.post<ParseBloodReportResponse>(
      url,
      {
        filename,
        file_path: filePath
      }
    );

    console.log('Response received:', data);
    return data;
  } catch (error: any) {
    console.error('Error in parseBloodReportByFilename:', error);
    console.error('Error details:', {
      message: error.message,
      response: error.response,
      request: error.request,
      config: error.config
    });

    // Handle network errors
    if (error.code === 'ERR_NETWORK' || error.message === 'Network Error') {
      console.error('Network error - check CORS and server connectivity');
      return {
        success: false,
        data: {
          biomarkers: [],
          summary: {}
        },
        error: 'Network error: Unable to connect to server. Please check your connection and try again.'
      };
    }

    if (error.response && error.response.data) {
      return error.response.data;
    }

    throw new Error(error.message || 'Failed to parse blood report');
  }
};

export interface ParseDexaReportResponse {
  success: boolean;
  data: Record<string, any>;
  error?: string;
}

export const parseDexaReportByFilename = async (
  filename: string,
  filePath?: string
): Promise<ParseDexaReportResponse> => {
  try {
    const baseURL = 'https://ukstaging.getscanned.me';
    const cleanBaseURL = baseURL.endsWith('/') ? baseURL.slice(0, -1) : baseURL;
    const client = axios.create({
      baseURL: cleanBaseURL,
      headers: { 'Content-Type': 'application/json' }
    });

    const { data } = await client.post<ParseDexaReportResponse>(
      `${API_V1_PREFIX}parse_dexa_report_by_filename`,
      { filename, file_path: filePath }
    );
    return data;
  } catch (error: any) {
    if (error.code === 'ERR_NETWORK' || error.message === 'Network Error') {
      return {
        success: false,
        data: {},
        error: 'Network error: Unable to connect to server. Please check your connection and try again.'
      };
    }
    if (error.response?.data) {
      return error.response.data;
    }
    throw new Error(error.message || 'Failed to parse DEXA report');
  }
};

